import { Box, Typography } from '@mui/material';

import React from 'react';

const DashboardPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Tela Principal
      </Typography>
      <Typography variant="body1">
        Adicione aqui as informações que deseja exibir ao usuário.
      </Typography>
    </Box>
  );
};

export default DashboardPage;
